import React from "react";
import { Flex, type FlexProps } from "@chakra-ui/react";

export function ChecklistItem({ children, ...props }: FlexProps) {
  return (
    <Flex
      align="center"
      borderBottom="1px"
      borderColor="base.border"
      gap={2}
      h="44px"
      fontSize={{ base: "xs", lg: "sm" }}
      fontWeight="medium"
      {...props}
    >
      {children}
    </Flex>
  );
}
